/**
 * Carril horizontal único del sitio (landing + /examples + barra de navegación).
 *
 * Por qué no `container` aquí: en Tailwind, `container` fija max-width por breakpoint
 * (sm/md/lg/…) y no garantiza coincidir con `max-w-7xl` (80rem). Mezclar ambos deja
 * la navbar y el contenido con anchos distintos en pantallas muy grandes.
 *
 * Si querés otro tope (p. ej. 90rem): cambiá `max-w-7xl` por `max-w-[90rem]` y ajustá
 * `SITE_NAV_EXPANDED_ROW` para mantener +90px (o el delta que quieras).
 */
export const SITE_CONTENT_OUTER = "mx-auto w-full max-w-[100rem] px-2 md:px-8";

/**
 * Fila dentro de la navbar expandida: mismo padding horizontal que el contenido,
 * pero ~90px más de ancho máximo que `SITE_CONTENT_OUTER` (80rem + 90px).
 * La caja `<nav>` sigue siendo `w-full` para el fondo/borde a lo ancho de la pantalla.
 */
export const SITE_NAV_EXPANDED_ROW =
  "mx-auto flex w-full max-w-[calc(80rem+90px)] items-center justify-between gap-2 px-2 md:gap-3 md:px-8 lg:gap-4 2xl:gap-5";
